import * as Yup from "yup";
import { validation } from "@/constants/validation.translation";

/**
 * Validation class for Email Template form
 * Contains validation schema for all email template fields
 */
class EmailTemplateValidationClass {
  
  /**
   * Email Template validation schema
   * @param {function} t - Translation function
   * @returns {Yup.ObjectSchema} Validation schema for email template
   */
  static emailTemplateValidation(t = (key) => key) {
    const { emailTemplate: emailTemplateValidation } = validation;
    
    return Yup.object().shape({
      slug: Yup.string()
        .required(t(emailTemplateValidation?.slug_required || "Slug is required"))
        .matches(/^[a-z0-9_-]+$/, t(emailTemplateValidation?.slug_invalid || "Slug must contain only lowercase letters, numbers, underscores, and hyphens"))
        .min(3, t(emailTemplateValidation?.slug_min_length || "Slug must be at least 3 characters"))
        .max(100, t(emailTemplateValidation?.slug_max_length || "Slug must not exceed 100 characters")),
      parameter: Yup.string().nullable(),
      email_templates: Yup.array()
        .of(
          Yup.object().shape({
            language_id: Yup.number()
              .required(t(emailTemplateValidation?.language_required || "Language is required"))
              .positive(t(emailTemplateValidation?.language_invalid || "Language must be a positive number")),
            title: Yup.string()
              .required(t(emailTemplateValidation?.title_required || "Title is required"))
              .min(2, t(emailTemplateValidation?.title_min_length || "Title must be at least 2 characters"))
              .max(255, t(emailTemplateValidation?.title_max_length || "Title must not exceed 255 characters")),
            subject: Yup.string()
              .required(t(emailTemplateValidation?.subject_required || "Subject is required"))
              .min(2, t(emailTemplateValidation?.subject_min_length || "Subject must be at least 2 characters"))
              .max(500, t(emailTemplateValidation?.subject_max_length || "Subject must not exceed 500 characters")),
            content: Yup.string()
              .required(t(emailTemplateValidation?.content_required || "Content is required"))
              .min(10, t(emailTemplateValidation?.content_min_length || "Content must be at least 10 characters")),
            uuid: Yup.string().nullable(),
          })
        )
        .min(1, t(emailTemplateValidation?.at_least_one_template || "At least one template is required"))
        .required(t(emailTemplateValidation?.templates_required || "Templates are required")),
    });
  }
}

export default EmailTemplateValidationClass;
